export default "__VITE_ASSET__930aecd9__"